import { useState } from 'react';

/** The results a bulk action is to be run over, held outside the table so it survives a refetch. */
export function useOutreachResultsSelection(scope: string) {
    const [selectedIds, setSelectedIds] = useState<Set<number>>(() => new Set());
    const [selectedScope, setSelectedScope] = useState(scope);

    // Another tab or location lists other results entirely, so the selection must not carry over. An
    // effect would clear it only after the new list had painted once with the old selection under it.
    if (selectedScope !== scope) {
        setSelectedScope(scope);
        setSelectedIds(new Set());
    }

    const toggleResult = (id: number) => {
        setSelectedIds((previous) => {
            const next = new Set(previous);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }

            return next;
        });
    };

    const selectResults = (ids: number[]) => {
        setSelectedIds(new Set(ids));
    };

    const clearSelection = () => {
        setSelectedIds(new Set());
    };

    return { selectedIds, toggleResult, selectResults, clearSelection };
}
